import contentApi from '@/services/plataforma/contentv2/content.js';
import postApi from '@/services/plataforma/contentv2/post.js';
import contentApiV1 from '@/services/plataforma/content.js';
import avaliaApi from '@/services/plataforma/avalia';
import ProgressType from '@/helpers/progressType';
import coursesApi from '@/services/plataforma/courses';
import academicMainSyncType from '~/helpers/academicMainSyncType';

export default {
  actionGetCourseByAcademicMainId({ commit, dispatch, rootGetters }, academicMainId) {
    return contentApi.getCourseByAcademicMainId(academicMainId)
      .then((response) => {
        const { data } = response;
        if (data?.renewed) {
          const signatureData = {
            shouldShowModal : data.shouldShowModal,
            expiredAt       : data.expiredAt,
            signature       : data.signature
          };
          localStorage.setItem("plataforma_noticeToken", JSON.stringify(signatureData));
        }

        commit('plataforma/courses/SET_USER_PERMISSIONS', data.permissions, { root: true });

        if (data?.context?.academicSyncTypeId === academicMainSyncType.MASTER && !rootGetters['plataforma/user/getterUserContext'].isStudent ) {
          return dispatch('actionGetSummaryPreview', academicMainId)
            .then((syncSummaryResponse) => {
              data.associatedAcademicMains = syncSummaryResponse.associatedAcademicMains;
              commit('SET_SELECTED_COURSE', data);
              return data;
            });
        }

        commit('SET_SELECTED_COURSE', data);
        return data;
      })
      .catch((e) => {
        return Promise.reject(e.response);
      });
  },

  actionGetImportCourseByAcademicMainId({ commit, rootGetters }, academicMainId) {
    const { academicSyncTypeId } = rootGetters['plataforma/newContent/getterCourse'].context;
    return contentApi.getContentToImport(academicMainId, academicSyncTypeId)
      .then((response) => {
        const { data } = response;

        return data;
      })
      .catch((e) => {
        return Promise.reject(e.response);
      });
  },

  actionGetSummaryPreview(_, academicMainId) {
    return contentApi.getSyncSummary({ academicMainId })
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e.response);
      });
  },
  actionGetContentByTopicId({ commit }, params) {
    return contentApi.getContentByTopicId(params)
      .then((response) => {
        if (response.data?.renewed) {
          const signatureData = {
            shouldShowModal : response.data.shouldShowModal,
            expiredAt       : response.data.expiredAt,
            signature       : response.data.signature
          };
          localStorage.setItem("plataforma_noticeToken", JSON.stringify(signatureData));
        }
        commit('plataforma/courses/SET_USER_PERMISSIONS', response.data.permissions, { root: true });
        commit('SET_SELECTED_CONTENT', response.data);

        return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e.response);
      });
  },
  actionGetContentByTopicIdWithoutUpdateVuex(_, params) {
    return contentApi.getContentByTopicId(params)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e.response);
      });
  },
  actionGetConfigurationsByTopicId(_, params) {
    return contentApi.getConfigurationsByTopicId(params)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error.response.data.error);
      });
  },
  actionSaveNewTopic({ commit }, params) {
    delete params.topic.parentTopicDeadlineAt;
    delete params.topic.parentTopicHasDeadline;
    const { isToReplacePosition } = params;

    return contentApi.postCreateTopic(params)
      .then((response) => {
        commit('NEW_TOPIC', {
          isToReplacePosition,
          ...response.data,
          ...((params.isToReplace || params.isToReplacePosition) && { index: params.index })
        });

        commit('SET_VERSION', response.data.version);

        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error.response.data.error);
      });
  },
  actionGroupTopic({ commit }, params) {
    return contentApi.postGroupTopic(params)
      .then((response) => {
        commit('NEW_MODULE_GROUP',
          response.data
        );

        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error.response.data.error);
      });
  },
  actionUpdateTopic({ commit }, params) {
    return contentApi.putUpdateTopic(params)
      .then((response) => {
        commit('EDIT_TOPIC', response.data);
        commit('SET_VERSION', response.data.version);

        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error.response.data.error);
      });
  },
  actionPatchTopic({ commit }, params) {
    return contentApi.patchUpdateTopic(params)
      .then((response) => {
        commit('EDIT_TOPIC', response.data.topic);
        commit('SET_VERSION', response.data.version);

        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error.response.data.error);
      });
  },
  actionPatchReorderTopic({ commit }, params) {
    commit('REORDER_TOPIC', params);

    return contentApi.patchReorderTopic(params)
      .then((response) => {
        commit('SET_VERSION', response.data.version);
        return Promise.resolve(response.data);
      }).catch((e) => {
        const rollbackParams = {
          topic       : params.topic,
          newSequence : params.oldSequence,
          oldSequence : params.newSequence
        };

        commit('REORDER_TOPIC', rollbackParams);
        return Promise.reject(e.response);
      });
  },
  actionPatchMoveToTopic({ commit }, params) {
    commit('MOVE_TO_TOPICS', params);

    return contentApi.patchMoveToTopic(params)
      .then((response) => {
        commit('SET_VERSION', response.data.version);
        return Promise.resolve(response.data);
      }).catch((e) => {
        const rollbackParams = {
          newParentTopicId : params.topic.parentTopicId,
          topic            : {
            ...params.topic,
            parentTopicId: params.newParentTopicId
          },
          isRollback: true
        };

        commit('MOVE_TO_TOPICS', rollbackParams);
        return Promise.reject(e.response);
      });
  },
  actionPatchTitleTopic({ commit }, params) {
    return contentApi.patchTitleTopic(params)
      .then((response) => {
        commit('CHANGE_TOPIC_TITLE', params);
        commit('SET_VERSION', response.data.version);
        return Promise.resolve(response.data);
      }).catch((e) => {
        return Promise.reject(e.response);
      });
  },
  actionUpdateTopicBanner({ commit }, params) {
    return contentApi.updateTopicBanner(params)
      .then((response) => {
        commit('CHANGE_TOPIC_BANNER', params);
        commit('SET_VERSION', response.data.version);
        return Promise.resolve(response.data);
      }).catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  actionPatchIsVisibleTopic({ commit }, params) {
    return contentApi.patchIsVisibleTopic(params)
      .then((response) => {
        commit('CHANGE_IS_VISIBLE_TOPIC', params);
        commit('SET_VERSION', response.data.version);
        return Promise.resolve(response.data);
      }).catch((e) => {
        return Promise.reject(e.response);
      });
  },
  actionDeleteTopic({ commit }, params) {
    return contentApi.deleteTopic(params)
      .then((response) => {
        commit('DELETE_TOPIC', params);
        commit('SET_VERSION', response.data.version);
        return Promise.resolve(response.data);
      }).catch((e) => {
        return Promise.reject(e.response);
      });
  },
  actionCopyCourseContent(_, { destinyMainId, originMainId, integration }) {
    return contentApiV1.copyContent({ destinyMainId, originMainId, integration })
      .then((result) => {
        return Promise.resolve(result.data);
      }).catch((err) => {
        return Promise.reject(err.response.data.error.message);
      });
  },

  actionAddProgress({ commit, rootGetters }, { academicMainId, topicId, progressTypeId }) {
    if (!rootGetters['plataforma/user/getterUserContext'].isStudent) {
      return;
    }

    const progressApiMethod = progressTypeId === ProgressType.ON_COMPLETION ? 'markScormProgress' : 'markProgress';

    return contentApi[progressApiMethod]({ academicMainId, topicId })
      .then(({ data }) => {
        const viewed = !data || !('viewed' in data) || data.viewed;
        commit('TOGGLE_TOPIC_VIEWED', { topicId, viewed });
        return Promise.resolve();
      })
      .catch((err) => {
        return Promise.reject(err.response.data.error.message);
      });
  },
  actionRemoveProgress({ commit }, { academicMainId, topicId }) {
    return contentApi.removeProgress({ academicMainId, topicId })
      .then(() => {
        commit('TOGGLE_TOPIC_VIEWED', { topicId, viewed: false });

        return Promise.resolve();
      })
      .catch((err) => {
        return Promise.reject(err.response.data.error.message);
      });
  },
  actionAnswerQuizQuestion({ commit }, params) {
    return contentApi.answerQuizQuestion(params)
      .then((response) => {
        commit('UPDATE_QUIZ_ATTEMPT_ANSWER', { topicId: params.topicId, attempts: response.data.attempts });

        return Promise.resolve();
      })
      .catch((error) => {
        return Promise.reject(error.response.data.error);
      });
  },
  actionFinishQuizAttempt({ commit }, params) {
    return contentApi.finishQuizAttempt(params)
      .then((response) => {
        commit('UPDATE_QUIZ_CONTENT', { topicId: params.topicId, content: response.data });

        return Promise.resolve();
      })
      .catch((error) => {
        return Promise.reject(error.response.data.error);
      });
  },
  actionReintegrateWebconference({ commit }, data) {
    return contentApi.reintegrateWebconference(data)
      .then((response) => {
        commit('CHANGE_WEBCONFERENCE_INTEGRATION_DATA', response.data);

        return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  actionGetWebconferenceProviders({ commit }, data) {
    return contentApi.getWebconferenceProviders(data)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  actionWebconferenceURL({ commit }, data) {
    return contentApi.getWebconferenceURL(data)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  actionGetWebconferenceRecords({ commit }, data) {
    return contentApi.getWebconferenceRecords(data)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  actionGetWebconferenceRecordURL({ commit }, data) {
    return contentApi.getWebconferenceRecordURL(data)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  actionCreatePost({ commit }, data) {
    return postApi.createPost(data)
      .then((response) => {
        commit('TOGGLE_TOPIC_VIEWED', { topicId: data.topicId, viewed: true });
        return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  actionGetGradeBookDetails(_, params) {
    return contentApi.getGradeBookDetails(params)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  actionEditPost({ commit }, data) {
    return postApi.editPost(data)
      .then((response) => {
        commit('ADD_NEW_POST', { topicId: data.topicId });

        return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  actionAddPostLike(_, data) {
    return postApi.addPostLike(data)
      .then(() => {
        return Promise.resolve();
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  actionRemovePostLike(_, data) {
    return postApi.removePostLike(data)
      .then(() => {
        return Promise.resolve();
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  actionAddTopicLike({ commit }, data) {
    return postApi.addTopicLike(data)
      .then(() => {
        commit('ADD_LIKE_TOPIC', { topicId: data.topicId });
        return Promise.resolve();
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  actionGetPostByParentPostId(_, params) {
    return postApi.getPostByParentPostId(params)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e.response);
      });
  },
  actionPersistGradeComposition(_, params) {
    return contentApi.persistGradeComposition(params)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error);
      });
  },
  actionRemoveTopicLike({ commit }, data) {
    return postApi.removeTopicLike(data)
      .then(() => {
        commit('REMOVE_LIKE_TOPIC', { topicId: data.topicId });
        return Promise.resolve();
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  actionAnswerTask({ commit }, data) {
    return contentApi.sendAnswer(data)
      .then((response) => {
        commit('UPDATE_TASK_ATTEMPTS', { ...data, ...response.data });

        return Promise.resolve(response.data);
      }).catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  actionGetReferences(_, data) {
    return contentApi.getReferences(data)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e.response);
      });
  },
  actionGetQuestionByAcademicAndTopicId(_, params) {
    return contentApi.getQuestionByAcademicAndTopicId(params)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e.response);
      });
  },
  actionAnswerAvaliaActivity({ commit }, data) {
    return contentApi.sendAnswerAvaliaActivity(data)
      .then((response) => {
        commit('UPDATE_AVALIA_ACTIVITY_ATTEMPT_ANSWER', { topicId: data.topicId });
        commit('TOGGLE_TOPIC_VIEWED', { topicId: data.topicId, viewed: true });

        return Promise.resolve(response.data);
      }).catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  actionGetAvaliaExternalActivities(_, params) {
    return contentApi.getAvaliaActivities(params)
      .then(response => {
        return Promise.resolve(response.data);
      })
      .catch(error => {
        return Promise.reject(error.response.data.error);
      });
  },
  actionSendEvaluateContent(_, data) {
    return contentApi.sendEvaluateContent(data)
      .then((response) => {
        return Promise.resolve(response.data);
      }).catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  actionCopyTopicContent(_, data) {
    return contentApi.copyContent(data)
      .then((response) => {
        return Promise.resolve(response.data);
      }).catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  actionGetContentOriginType(_, params) {
    return contentApi.getContentOriginType(params)
      .then((result) => {
        return Promise.resolve(result.data);
      }).catch((err) => {
        return Promise.reject(err.response.data.error.message);
      });
  },
  actionImportMarketplaceContentsList({ commit }, data) {
    return contentApi.importMarketplaceContentsList(data)
      .then((result) => {
        const { successList } = result.data;

        if (successList?.length) {
          for (const topic of successList) {
            commit('NEW_TOPIC', {
              ...topic
            });
          }

          commit('SET_VERSION', successList[successList.length - 1].version);
        }

        return Promise.resolve(result.data);
      }).catch((err) => {
        return Promise.reject(err.response.data.error.message);
      });
  },
  actionGetCorrectionEnrollments(_, { academicMainId, topicId, params }) {
    return contentApi.getCorrectionEnrollments({ academicMainId, topicId, params })
      .then((result) => {
        return Promise.resolve(result.data);
      }).catch((err) => {
        return Promise.reject(err.response.data.error.message);
      });
  },
  actionGetCorrectionGroups(_, { academicMainId, topicId, params }) {
    return contentApi.getCorrectionGroups({ academicMainId, topicId, params })
      .then((result) => {
        return Promise.resolve(result.data);
      }).catch((err) => {
        return Promise.reject(err.response.data.error.message);
      });
  },
  actionGetGroupAnswers(_, { academicMainId, topicId, groupId }) {
    return contentApi.getGroupAnswers({ academicMainId, topicId, groupId })
      .then((result) => {
        return Promise.resolve(result.data);
      }).catch((err) => {
        return Promise.reject(err.response.data.error.message);
      });
  },
  actionGetCorrectionCount(_, { academicMainId, topicId }) {
    return contentApi.getCorrectionCount({ academicMainId, topicId })
      .then((result) => {
        return Promise.resolve(result.data);
      }).catch((err) => {
        return Promise.reject(err.response.data.error.message);
      });
  },
  actionClearAnswers({ commit }, data) {
    return avaliaApi.clearAnswers(data)
      .then((result) => {
        commit('CLEAR_ANSWERS', data.topicId);
        return Promise.resolve(result.data);
      })
      .catch((e) => {
        return Promise.reject(e.response);
      });
  },
  actionGetModuleDefaultGradeBooks(_, data) {
    return contentApi.getModuleDefaultGradeBooks(data)
      .then((result) => {
        return Promise.resolve(result.data);
      })
      .catch((e) => {
        return Promise.reject(e.response);
      });
  },
  actionCreateModuleDefaultGradeBooks(_, data) {
    return contentApi.createModuleDefaultGradeBooks(data)
      .then((result) => {
        return Promise.resolve(result.data);
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  actionUpdateModuleDefaultGradeBooks(_, data) {
    return contentApi.updateModuleDefaultGradeBooks(data)
      .then((result) => {
        return Promise.resolve(result.data);
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  actionDeleteModuleDefaultGradeBooks(_, id) {
    return contentApi.deleteModuleDefaultGradeBooks(id)
      .then((result) => {
        return Promise.resolve(result.data);
      })
      .catch((e) => {
        return Promise.reject(e.response);
      });
  },
  actionPatchApprovalFlow({ commit }, params) {
    return coursesApi.patch(params)
      .then((response) => {
        commit('SET_APPROVAL_FLOW_DATA', params.data);

        if ('approvalFlowStatusId' in params.data) {
          location.reload(); // this is an workaround to refresh user permissions because v-permission directive isn`t reactive. To fix this, we need to refactor all locations with v-permission to use helper helpers/permission.js in this helper is reactive because it doesn`t use directive use vuex store
        }

        return Promise.resolve(response.data);
      }).catch((e) => {
        return Promise.reject(e.response);
      });
  },
  actionGetEulaByProviderAlias({ commit }, { providerAlias }) {
    return contentApi.getEulaByProviderAlias({ providerAlias })
      .then((response) => {
        commit('SET_EULA_ITEM', {
          ...response.data,
          providerAlias
        });
        return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  actionAcceptEula({ commit }, params) {
    return contentApi.acceptEula(params)
      .then((response) => {
        commit('SET_EULA_ACCEPTED', params.providerAlias);
        return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  actionPatchIsNotifySyncUpdateEnabled({ commit }, { academicMainId, isNotifySyncUpdateEnabled }) {
    return coursesApi.patchIsNotifySyncUpdateEnabled(academicMainId, isNotifySyncUpdateEnabled)
      .then(response => {
        commit('SET_IS_NOTIFY_SYNC_UPDATE_ENABLED', { isNotifySyncUpdateEnabled: isNotifySyncUpdateEnabled });

        return Promise.resolve(response.data);
      })
      .catch(error => {
        return Promise.reject(error.response.data.error);
      });
  },
  actionSendContentToAi({ commit }, params) {
    return contentApi.sendContentToAI(params)
      .then((response) => {
        commit('SET_AUTO_GRADE_PENDING', true);
        return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  }
};
